<div>
    <div style="margin-bottom: 1em">
        <h1>Allgemeine Merkmale</h1>
        <app-common-feature-add style="margin-right: 5px;" (addedFeature)="addCommonFeature($event)">
        </app-common-feature-add>
        <button matButton="elevated" color="accent" *ngIf="!editOrder" (click)="editOrder = true">
            Reihenfolge bearbeiten
        </button>
        <button matButton="elevated" color="primary" *ngIf="editOrder" (click)="saveOrder()">
            Änderungen speichern
        </button>
        <button matButton="elevated" color="warn" *ngIf="editOrder" (click)="cancel()">
            Abbrechen
        </button>

    </div>

    <div *ngFor="let feature of commonFeatureList; let i = index" class="item">
        <app-common-feature-item class="col1" [commonFeature]="feature" (updatedFeature)="updateCommonFeature($event)"
            (deletedFeature)="deleteCommonFeature($event)">
        </app-common-feature-item>
        <div class="arrows" *ngIf="editOrder" class="col2">
            <button matButton="elevated" [class]="isTopOfList(feature) ? '' : 'btn_green'"
                [disabled]="isTopOfList(feature)" (click)="moveCommonFeature(feature, true)" [disableRipple]="true">
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
            </button>
            <button matButton="elevated" [class]="isBottomOfList(feature) ? '' : 'btn_green'"
                [disabled]="isBottomOfList(feature)" (click)="moveCommonFeature(feature, false)" [disableRipple]="true">
                <i class="fa fa-arrow-down" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</div>